import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fill="#474747"><path d="M9 8v4.281A1.995 1.995 0 008 12a2 2 0 102 2V9h4v3.281A1.995 1.995 0 0013 12a2 2 0 102 2V8h-5z" style={{
        marker: "none"
      }} overflow="visible" /><path d="M1.969 0S1 1 1 2v12c0 1.01-1 2-1 2h1s.423-.427.719-1h1C2.423 15.573 2 16 2 16h1s1-1.021 1-2v-2h1v-1H4V6h8v1h3V2c0-1 .969-2 .969-2h-3S12 1 12 2v3H4V2c0-1 .969-2 .969-2zm.312 1h1c-.152.306-.28.652-.28 1H2c0-.348.128-.694.28-1zm11 0h1c-.152.306-.28.652-.28 1h-1c0-.348.128-.694.28-1zM2.001 3h1v1H2zm11 0h1v1h-1zM2 5h1v1H2zm11 0h1v1h-1zM2 7h1v1H2zm0 2h1v1H2zm0 2h1v1H2zm0 2h1v1H2z" style={{
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;